/**
 * Capitan iscroll.js v1.0.0
 *
 * Copyright brandung GmbH & Co.KG
 * http://www.brandung.de/
 *
 *
 * Date: 2018-08-14
 * MIT License (MIT)
 */
import Capitan from '../../code/js/Capitan/Capitan';
import CapSmartResize from '../../code/js/Capitan/es6/CapSmartResize';
import IScroll from 'iscroll/build/iscroll';
var _ = {
  defaults: {
    componentSelector: '.scrollable',
    selector: {
      mobile: 'nm-panel'
    },
    state: {
      active: 'scrollable--active'
    }
  }
};
var o = _.defaults;
var activeScroller = [];
/**
 * Initialize Tabs
 *
 * @desc Initializes each scroller.
 */

export var initializeScroll = function initializeScroll(components) {
  var scrollComponents = components;
  scrollComponents.forEach(function (el, index) {
    if (el.classList.contains('js-init') === false) {
      el.classList.add('js-init');
      el.classList.add('scrollable-' + index);
      activeScroller[index] = new IScroll('.scrollable-' + index, {
        mouseWheel: true,
        scrollbars: 'custom',
        disablePointer: false,
        disableTouch: false,
        disableMouse: false,
        preventDefault: true,
        useTransition: false,
        eventPassthrough: false
      });
    }
  });
  refreshScroller();
};
export function refreshScroller() {
  activeScroller.forEach(function (el) {
    el.refresh();
    var isScrollerVisible = el.wrapper.lastElementChild.children[0].style.display;
    var scrollWrapper = el.wrapper;

    switch (isScrollerVisible) {
      case 'block':
        scrollWrapper.classList.remove(o.state.active);
        break;

      case 'none':
        scrollWrapper.classList.add(o.state.active);
        scrollWrapper.lastElementChild.style.background = 'transparent';
        break;
    }
  });
}
/**
 * initialize the component
 * @export function
 */

export function init() {
  console.log('iScroll');
  CapSmartResize(refreshScroller, 100, false, this);
  initializeScroll(document.querySelectorAll(o.componentSelector));
}
export default initializeScroll;